<div class="sh-form-dual-list">
  <div class="sh-dual-list__list" [id]="id + 'left-list'" [class.-sh-disabled]="isDisabled">
    @if (hasHeaders) {
      <div class="sh-form-dual-list__list__header">{{ leftHeaderText ? leftHeaderText : " " }}</div>
    }
    <div class="sh-form-dual-list__list__body" [class.-sh-headerless]="!hasHeaders">
      <div class="sh-input-field-with-icon">
        <input
          #searchInput
          type="search"
          autocomplete="off"
          [id]="id + 'left-search-input'"
          [formControl]="leftSearchControl"
          [placeholder]="i18n.leftSearchPlaceholderMsg"
          class="sh-input-field"
          />
        <svg sh-icon class="sh-input-field-with-icon__icon" [name]="'search'" [size]="sizes.SMALL" aria-hidden="true"></svg>
      </div>

      <div class="sh-form-dual-list__list__body__content">
        @if (leftLoading$ | async) {
          <div id="sh-form-dual-list__list__body__content__info-row" class="sh-dual-table-info-row">
            {{ i18n.leftLoadingMsg }}
          </div>
        }

        @if (leftHasError && !(leftLoading$ | async)) {
          <div id="sh-form-dual-list__list__body__content__info-row" class="sh-dual-table-info-row">
            {{ i18n.leftLoadingFailedMsg }}
          </div>
        }

        @if (!!i18n.leftPlaceholderMsg && (leftItems$ | async)?.length === 0) {
          <div
            id="dual-list-right-placeholder-row"
            class="sh-form-dual-list__list__body__content__info-row"
            >
            {{ i18n.leftPlaceholderMsg }}
          </div>
        }

        @for (item of filteredLeftItems$ | async; track item; let i = $index) {
          <div
            [class.-sh-disabled]="item.disabled"
            [class.selected]="item.checked"
            class="sh-form-dual-list__list__body__content__row"
            [title]="isDisabled ? disabledMsg : item.disabled ? item.disabledInfoMsg : item.label"
            (dblclick)="onMoveOneRight(item)"
            (click)="onSelectLeft(item, i)"
            (keydown.enter)="onSelectLeft(item, i)"
            >
            {{ item.label }}
          </div>
        }
      </div>
    </div>
  </div>

  <div class="sh-form-dual-list__button-column">
    @for (actionItem of moveActionItems$ | async; track actionItem) {
      <sh-action-item [item]="actionItem"></sh-action-item>
    }
  </div>

  <div class="sh-dual-list__list" [class.-sh-is-invalid]="invalid" [id]="id + '-right-list'" [class.-sh-disabled]="isDisabled">
    @if (leftHeaderText || rightHeaderText) {
      <div class="sh-form-dual-list__list__header">{{ rightHeaderText ? rightHeaderText : " " }}</div>
    }

    <div class="sh-form-dual-list__list__body" [class.-sh-headerless]="!hasHeaders">
      <div class="sh-input-field-with-icon">
        <input
          #searchInput
          type="search"
          autocomplete="off"
          [id]="id + '-right-search-input'"
          [formControl]="rightSearchControl"
          [placeholder]="i18n.rightSearchPlaceholderMsg"
          class="sh-input-field"
          />
        <svg sh-icon class="sh-input-field-with-icon__icon" [name]="'search'" [size]="sizes.SMALL" aria-hidden="true"></svg>
      </div>

      <div class="sh-form-dual-list__list__body__content">
        @if (rightLoading$ | async) {
          <div id="dual-list-right-loading-row" class="sh-form-dual-list__list__body__content__info-row">
            {{ i18n.rightLoadingMsg }}
          </div>
        }

        @if (rightHasError && !(rightLoading$ | async)) {
          <div id="dual-list-right-error-row" class="sh-form-dual-list__list__body__content__info-row">
            {{ i18n.rightLoadingFailedMsg }}
          </div>
        }

        @if (!!i18n.rightPlaceholderMsg && (rightItems$ | async)?.length === 0) {
          <div
            id="dual-list-right-placeholder-row"
            class="sh-form-dual-list__list__body__content__info-row"
            >
            {{ i18n.rightPlaceholderMsg }}
          </div>
        }

        @for (item of filteredRightItems$ | async; track item; let i = $index) {
          <div
            [class.-sh-disabled]="item.disabled"
            [class.selected]="item.checked"
            [title]="isDisabled ? disabledMsg : item.disabled ? item.disabledInfoMsg : item.label"
            class="sh-form-dual-list__list__body__content__row"
            (click)="onSelectRight(item, i)"
            (keydown.enter)="onSelectRight(item, i)"
            (dblclick)="onMoveOneLeft(item)"
            >
            {{ item.label }}
          </div>
        }
      </div>
    </div>
  </div>
</div>
